export default __webpack_public_path__ + "static/media/ER.3501f4a7.svg";